import { useEffect, useRef } from 'react';
import { useStepActions } from '../store/stepStore';
import { createContextLogger } from '../utils/logger';

const logger = createContextLogger('useAppInitialization');

export const useAppInitialization = (): void => {
  const { fetchSteps } = useStepActions();
  const initialized = useRef<boolean>(false);

  useEffect(() => {
    if (!initialized.current) {
      // Fetch transforms on app initialization
      fetchSteps().catch((error: Error) => {
        logger.error('Failed to initialize app:', error);
      });
      initialized.current = true;
    }
  }, [fetchSteps]); // Empty dependency array since we only want to run this once
};

export default useAppInitialization;
